import { useState, useEffect } from "react";
import api from "../services/api";

/**
 * useChatRooms
 *
 * Resolve as salas de chat do usuário logado (GET /chat/rooms — cria as que
 * faltarem no backend). Pode devolver 0 (admin), 1 (professor, ou aluno sem
 * professor — só a global) ou 2 salas (aluno com professor: a dele + a
 * global). `enabled` evita a chamada quando o usuário não tem chat
 * disponível (feature flag desligada, role sem acesso, etc.).
 */
export function useChatRooms(enabled) {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setRooms([]);
      setError(null);
      return undefined;
    }

    let ignore = false;
    setLoading(true);
    setError(null);

    api
      .get("/chat/rooms")
      .then((res) => {
        if (!ignore) setRooms(res.data);
      })
      .catch((err) => {
        if (!ignore) setError(err);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [enabled]);

  return { rooms, loading, error };
}
